import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { useTheme } from '../../providers';
import { StyledEditableText, StyledInnerText, StyledWrapper, } from './EditableText.style';
export function EditableText({ title, text, size, onChange, }) {
    const theme = useTheme();
    const [innerText, setInnerText] = useState(text);
    const inputSize = useMemo(() => {
        var _a;
        return ({
            width: (_a = size === null || size === void 0 ? void 0 : size.width) !== null && _a !== void 0 ? _a : theme.Form.InputSize.Small.width,
            height: theme.Form.InputSize.Small.height,
            fontSize: theme.Typography.Size.Body.FontSize,
        });
    }, [size, theme]);
    return (_jsx(StyledWrapper, { children: _jsx(StyledEditableText, { size: inputSize, editable: {
                onChange: setInnerText,
                onEnd: () => onChange(innerText),
                tooltip: title,
                triggerType: ['text'],
                enterIcon: null,
                autoSize: false,
                text: innerText,
            }, style: { marginBottom: 0 }, children: _jsx(StyledInnerText, { size: inputSize, children: innerText }) }) }));
}
//# sourceMappingURL=EditableText.js.map